<template>
  <v-footer app height="32" class="footer-bar">
    <span class="footer-copy">© {{ new Date().getFullYear() }} Loesus Pedagogia</span>
    <v-spacer />
    <span class="footer-dev" v-if="profileStore.profile && appStore.app && profileStore.profile.dev">
      <span class="text-disabled">{{ appStore.app.name }}</span>
      <span class="text-disabled mx-1">·</span>
      <span class="text-disabled">{{ appStore.app.id }}</span>
    </span>
  </v-footer>
</template>

<script>
import { useProfileStore } from '@/stores/profile'
import { useAppStore } from '@/stores/appdata.js'

export default {
  data() {
    return {
      profileStore: useProfileStore(),
      appStore: useAppStore()
    }
  }
}
</script>

<style scoped>
.footer-bar {
  background-color: rgb(var(--v-theme-surface)) !important;
  border-top: 1px solid rgba(255,255,255,0.06) !important;
  padding: 0 16px !important;
}
.footer-copy {
  font-size: 0.68rem;
  color: rgba(255,255,255,0.25);
  letter-spacing: 0.04em;
}
.footer-dev {
  font-size: 0.68rem;
}
</style>
